import EventBus from '../components/event-bus';
import {HTTP} from '../http-common';
import moment from 'moment';
export default {
//module.exports = {
    data() {
        return {
            currentEnvironment: false,
            role: {
                id: '',
                name: '',
            },
            ContactSideDetailAutoCloseSeconds: 2,
            extension_slug: "",
            safetyURL: "",
            location: "",
            system_year: "",
            persmission: "null",
            userPermissions: [],
            isLoggedIn: false,
            isBackend: false,
            menu_data: '',
        }
    },
    created() {
        /*console.log("mixin created");*/
    },
    beforeMount() {

    },
    mounted: function () {
        $("html, body").animate({scrollTop: 0}, 10);
        if (process.env.NODE_ENV == 'production') {
            this.currentEnvironment = false;
        } else {
            this.currentEnvironment = true;
        }
    },
    methods: {
      capitalizeFirstLetter: function(string) {
            if (typeof string !== 'string' || string == null || string == 'null') return ''
                return string.charAt(0).toUpperCase() + string.slice(1);
        },
        setCookie: function (cname, cvalue, exdays) {
            /*var domains = ['staging.hr.vtc.systems', 'staging.safety.vtc.systems'];*/
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            /*for (var i = 0; i < domains.length; i++) {
             document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;domain=" + domains[i];
             }*/
        },
        getCookie: function (cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        getBuildVersion: function () {
            var self = this;
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
            };

            HTTP.get("build-version", '', config)
                .then(function (data) {
                    if (data.data.status == 'success') {
                        let current_build = window.localStorage.getItem("build_version");
                        let latest_build =  data.data.content;
                        if(current_build == null) {
                            localStorage.setItem("build_version", data.data.content);
                        } else if(current_build != undefined && current_build == '' ){
                            localStorage.setItem("build_version", data.data.content);
                        } else if(current_build != latest_build){
                            localStorage.setItem("build_version", data.data.content);
                            location.reload(true);
                        }
                    }
                })
                .catch(function (err) {
                    console.log(err);
                    if (err.response.status == 0) {
                        self.error = "Remote server can not be reachable";
                    } else {
                        //redirect to login page if user not authenticated
                        if (err.response.status == 401) {
                            localStorage.removeItem('user_obj');
                            localStorage.removeItem('api_token');
                            self.$router.push("/login");
                        }
                    }
                });
        },
        getPermissions: function () {
            var self = this;
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
            };
            /*var fields = {

             };*/
            HTTP.post("user/permission", '', config)
                    .then(function (response) {
                        if (response.data.status == 'success') {
                            self.userPermissions = [];
                            //self.extension_slug = response.data.company.name;
                            self.role.id = response.data.roles.id;
                            self.role.name = response.data.roles.name;
                            self.system_year = response.data.system_year;
                            $.each(response.data.permissions, function (i) {
                                //console.log(response.data.permissions[i].id + " : " + response.data.permissions[i].name);
                                self.userPermissions.push(response.data.permissions[i].name);
                            });
                            //console.log(self.userPermissions);
                            EventBus.$emit('role', false, response.data.roles.id, response.data.roles.name, response.data.system_year, self.userPermissions);
                            EventBus.$emit('contact', false, response.data.company.name, localStorage.getItem("api_token"));
                        }
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                self.$router.push("/login");
                            }
                        }
                    });
        },
        MenuClose: function () {
            var self = this;
            $('#toggle').removeClass('active');
            $('#overlay').removeClass('open');
            $('.middle-menu').removeClass("menu-toggle")
            var expiry = localStorage.getItem("expiry");
            if (expiry != null) {
                if (new Date(expiry) < new Date()) {
                    self.logout();
                }
            } else {
                localStorage.clear();
                this.isBackend = false;
                this.$router.push("/login");
            }
        },
        checkLogin: function (redirectUrl) {
            redirectUrl = (redirectUrl === null || typeof (redirectUrl) === "undefined" || redirectUrl == '') ? 'login' : redirectUrl;
            /* Check Login */
            var check = window.localStorage.getItem("api_token");
            if (check != null && window.localStorage.getItem("api_token") != '') {
                this.isLoggedIn = true;
            } else {
                this.logout(redirectUrl);
            }
            //console.log("Checking user session status")
            this.persmission = "data";
            return "data";
        },
        logout: function (redirectUrl) {
            var ssoLogin = true;
            if(ssoLogin !== undefined && ssoLogin != '' && ssoLogin){
                let appSlug = process.env.PROJECT_SLUG;
                let ssoUrl = process.env.SSO_ROOT_URL;
                const redirectUrl = window.location.href;

                window.location.href = `${ssoUrl}/logout?redirect_url=${encodeURIComponent(redirectUrl)}&slug=${appSlug}`;
            }else{
                let path = window.location.pathname;
                let segments = path.split("/");
                redirectUrl = (redirectUrl === null || typeof (redirectUrl) === "undefined" || redirectUrl == '') ? '' : redirectUrl;
                localStorage.clear();
                this.setCookie('vvg_sso_auth_token', '', 365);
                this.isBackend = false;
                if (redirectUrl == 'login') {
                    openDirectLink('/login');
                } else if (redirectUrl == '') {
                    if (segments[1] === "backend") {
                        openDirectLink('/');
                    } else if (segments[1] === "event-calendar") {
                        openDirectLink('/');
                    } else {
                        let redirectPath = '';
                        $.each(segments, function (i) {
                            if (i > 0) {
                                redirectPath += '/' + segments[i];
                            }
                        });
                        openDirectLink(redirectPath);
                    }
                } else {
                    openDirectLink("/login?redirect_url=" + redirectUrl);
                    //this.$router.push("/login?redirect_url=" + redirectUrl);
                }
                //this.$router.push("/login");
            }
        },
        showLoader: function () {
            $(".loading-container").show();
        },
        hideLoader: function () {
            //setTimeout(function () {
            $(".loading-container").hide();
            //}, 1700);
            let windowHeight = $(window).height();
            let headerHeight = $(".navbar-default").outerHeight();
            let contentHeight = $("#page-content-wrapper").outerHeight();
            let footerHeight = $(".admin-footer").outerHeight();
            if ((headerHeight + contentHeight) < windowHeight) {
                /*alert(parseInt($(".admin-footer").css("marginTop").replace('px', '')));
                 alert(parseInt($(".admin-footer").css("marginBottom").replace('px', '')));*/
                /*alert("Window : " + $(window).height());
                 alert("navbar-default : " + $(".navbar-default").outerHeight());
                 alert("page-content-wrapper : " + $("#page-content-wrapper").outerHeight());
                 alert("admin-footer : " + $(".admin-footer").outerHeight());
                 /*alert("Margin will be : "+ Math.round(windowHeight -headerHeight - (contentHeight - footerHeight)-15));*/
                $(".admin-footer").css({"margin-top": Math.round(windowHeight - headerHeight - (contentHeight - footerHeight) - 10) + "px"});
            } else {
                $(".admin-footer").removeAttr("style");
            }
        },
        getUserFromToken(token, redirect) {
            var self = this;

            var config = {
                headers: {Authorization: "Bearer " + token},
                /*params: {
                 'type': self.categoryType,
                 }*/
            };
            HTTP.get('getuserdata', config)
                    .then(function (response) {
                        /*console.log(response.data);*/
                        if (response.data.status == "success") {
                            //self.timezones = response.data.content;
                            window.localStorage.setItem("expiry", moment(new Date()).add(6, 'h').toDate());
                            window.localStorage.setItem("api_token", token);
                            window.localStorage.setItem("user_obj", JSON.stringify(response.data.content.user_obj));
                            window.localStorage.setItem("profile_image", response.data.content.user_obj.profile_image);

                            self.setCookie('vvg_sso_auth_token', token, 365);

                            EventBus.$emit('logged-in',
                                    true,
                                    response.data.content.user_obj["first_name"],
                                    response.data.content.user_obj["last_name"],
                                    response.data.content.user_obj["email"],
                                    response.data.content.user_obj["profile_image"]
                                    );
                            if (redirect == 'login') {
                                self.$router.push("/");
                            }
                        } else {
                            $("#errorMsg").html(response.data.message);
                            if (response.data.content.length > 0) {
                                var err = "";
                                err += response.data.content + "<br>";
                                $("#errorMsg").html(err);
                            }
                        }
                    })
                    .catch(function (err) {
                        self.setCookie('vvg_sso_auth_token', '', 365);
                        self.Registerbtn = "Register";
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            $("#errorMsg").html(err.response.data.message);
                            if (err.response.data.content.length > 0) {
                                var err = "";
                                err += err.response.data.content + "<br>";
                                $("#errorMsg").html(err);
                            }
                        }
                        openDirectLink('/');
                    });

        },
        stringTrim: function (string, length) {
            length = (typeof length !== 'undefined') ? length : 20;
            var string1 = (string.length > length) ? string.substring(0, length) + '...' : string;
            return string1;
        },
        getFirstChar: function (string) {
            if (string != '') {
                let getName = string.charAt(0);
                return getName.toUpperCase();
            } else {
                return 'V';
            }
        },
        getMenus() {
            var self = this;
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                params: {'search': ''}
            };
            HTTP.get("getcompanylocation", config)
                    .then(function (response) {
                        self.menu_data = response.data.content;
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
        },
        setWidthToContactContainer: function (time) {
            time = (time === null || typeof (time) === "undefined" || time == '') ? 300 : time;
            var screenWid = $(window).width();
            if (screenWid > 767) {
                setTimeout(function () {
                    var pageContent = $('.admin-page-content');
                    var pageContentSidePad = parseInt(pageContent.css('padding-right')) + parseInt(pageContent.css('padding-left'));
                    var contactDetail = $(".page-sidebar").outerWidth();
                    var sideMenu = $("#sidebar-wrapper").outerWidth();
                    if ($('.app-sidebar-right').attr('class').indexOf('toggled') != -1) {
                        sideMenu = 50;
                    }
                    $(".contact-container").width(Math.ceil(screenWid - pageContentSidePad - contactDetail - sideMenu));
                }, time);
            }
        },
        menuTtoggleDesktop: function (from) {
            var self = this;
            console.log('menuTtoggleDesktop' + ' : ' + from);
            $(".app-sidebar-right").toggleClass("toggled-2");
            if (from == 'extension') {
                self.setWidthToContactContainer(550);
            }
        },
        menuTtoggleMobile: function (from) {
            var self = this;
            console.log('menuTtoggleMobile' + ' : ' + from);
            $(".app-sidebar-right").toggleClass("toggled");
            $('#menu ul').hide();
            if (from == 'extension') {
                self.setWidthToContactContainer(550);
            }
        },
        utcToLocal: function (dateTime, format) {
            var self = this;
            var local = moment.utc(dateTime).local().format(format);
            return local;
        },
        validEmail : function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        jumpToInputPage: function (pageNumber, totalRecord, perPage) {
            var self = this;
            var reg = /^\d+$/;
            if (pageNumber <= 0 || pageNumber == '') {
                pageNumber = 1;
            } else if (pageNumber > self.pageNumberList(totalRecord, perPage)) {
                pageNumber = self.pageNumberList(totalRecord, perPage);
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                }
            } else if (!String(pageNumber).match(reg)) {
                pageNumber = 1;
            }
            return pageNumber;
        },
        pageNumberList: function (totalRecord, perPage) {
            var self = this;
            var totalRecord = totalRecord;
            var count = 0;
            for (var i = 0; totalRecord > 0; i++) {
                totalRecord = totalRecord - perPage;
                count++;
            }
            return count;
        },
        calculateStartRecordEndRecord: function (currentPage1, perPage1, totalRecords1) {
            let serverPage = 0;
            let perPage = 0;
            let totalRecords = 0;
            var firstLoad = true;
            var firstRecord = 0;
            var lastRecord = 0;
            if (perPage1 == "All") {
                if (totalRecords1 == 0) {
                    firstRecord = 1;
                } else {
                    firstRecord = 1;
                }
                lastRecord = totalRecords1;
            } else {
                 serverPage = Number(currentPage1);
                 perPage = Number(perPage1);
                 totalRecords = Number(totalRecords1);
                 firstLoad = true;
                 firstRecord = 0;
                 lastRecord = 0;

                var page = serverPage;
                for (var i = 1; i <= page; i++) {
                    if (firstLoad == true) {
                        firstRecord = lastRecord + 1;
                        lastRecord = perPage;
                        firstLoad = false;
                    } else {
                        firstRecord = lastRecord + 1;
                        lastRecord = (perPage * i);
                    }
                }

                if (totalRecords != 0) {
                    if (lastRecord > totalRecords) {
                        lastRecord = totalRecords;
                    }
                } else if (totalRecords == 0) {
                    firstRecord = 0;
                    lastRecord = 0;
                }
            }

            return firstRecord + " - " + lastRecord;
        },
        getSignedUrlPath(file){
            var config = {
                headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                params: {
                    file: file,
                }
            };
            HTTP.get("getsignedurlpath", config)
                .then(function (response) {
                    window.open(response.data.file_path);
                })
                .catch(function (err) {
                });
        },
    }
}



// WEBPACK FOOTER //
// ./src/mixins/sessionmixin.js